import validateURL from '@paskills/validation/lib/validators/url';
import i18n from '@yandex-int/i18n';
import { validationMap, ValidationResult } from 'client/lib/validate';
import { UserAgreementOrDraft } from 'client/model/userAgreement';
import * as keyset from 'i18n/Settings';

export type ValidationErrResult = ValidationResult<{ idx: number; field: 'name' | 'url' }>;

const t = i18n(keyset);

export const userAgreementsValidators = validationMap<UserAgreementOrDraft[], ValidationErrResult>((agreements) => {
    const result: ValidationErrResult[] = [];
    const names = new Set<string>();
    const urls = new Set<string>();
    agreements.forEach((agreement, idx) => {
        if (agreement.name === '') {
            result.push({ error: t('ua-validity-name-req'), field: 'name', idx });
        }
        if (agreement.url === '') {
            result.push({ error: t('ua-validity-url-req'), field: 'url', idx });
        }
        if (names.has(agreement.name)) {
            result.push({ error: t('ua-validity-url-uniq'), field: 'name', idx });
        }
        if (urls.has(agreement.url)) {
            result.push({ error: t('ua-validity-url-uniq'), field: 'url', idx });
        }
        if (agreement.name.length >= 128) {
            result.push({ error: t('ua-validity-name-long'), field: 'name', idx });
        }
        if (agreement.url.length >= 128) {
            result.push({ error: t('ua-validity-url-long'), field: 'url', idx });
        }
        if (validateURL(agreement.url, true)) {
            result.push({ error: t('ua-validity-url-incorrect'), field: 'url', idx });
        }
        names.add(agreement.name);
        urls.add(agreement.url);
    });
    return result;
});

export const userAgreementsComparator = (a: UserAgreementOrDraft, b: UserAgreementOrDraft) => a.order - b.order;
